import React from 'react';
import { Wallet, CreditCard, Building, Bitcoin, Loader2 } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '../../components/ui/dialog';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../components/ui/select';

export const WithdrawDialog = ({
  open, onOpenChange, balance, minWithdrawal,
  amount, onAmountChange, method, onMethodChange,
  details, onDetailsChange, onSubmit, submitting,
}) => {
  const placeholders = {
    paypal: 'tu@email.com',
    bank_transfer: 'Banco - Cuenta',
    crypto: 'Wallet address',
  };
  const labels = {
    paypal: 'Email de PayPal',
    bank_transfer: 'Numero de Cuenta',
    crypto: 'Direccion de Wallet',
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md bg-slate-900 border-slate-700" data-testid="withdraw-dialog">
        <DialogHeader>
          <DialogTitle className="text-white">Solicitar Retiro</DialogTitle>
          <DialogDescription className="text-slate-400">
            Balance disponible: ${(balance || 0).toFixed(2)}
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4 py-4">
          <div className="space-y-2">
            <Label className="text-slate-300">Monto a retirar ($)</Label>
            <Input type="number" value={amount} onChange={(e) => onAmountChange(e.target.value)}
              placeholder={`Minimo $${minWithdrawal || 20}`} className="bg-slate-800 border-slate-700 text-white" data-testid="withdraw-amount" />
          </div>
          <div className="space-y-2">
            <Label className="text-slate-300">Metodo de Pago</Label>
            <Select value={method} onValueChange={onMethodChange}>
              <SelectTrigger className="bg-slate-800 border-slate-700 text-white" data-testid="payment-method">
                <SelectValue />
              </SelectTrigger>
              <SelectContent className="bg-slate-900 border-slate-700">
                <SelectItem value="paypal" className="text-white hover:bg-slate-800">
                  <div className="flex items-center gap-2"><CreditCard size={16} className="text-blue-400" />PayPal</div>
                </SelectItem>
                <SelectItem value="bank_transfer" className="text-white hover:bg-slate-800">
                  <div className="flex items-center gap-2"><Building size={16} className="text-green-400" />Transferencia Bancaria</div>
                </SelectItem>
                <SelectItem value="crypto" className="text-white hover:bg-slate-800">
                  <div className="flex items-center gap-2"><Bitcoin size={16} className="text-amber-400" />Criptomoneda</div>
                </SelectItem>
              </SelectContent>
            </Select>
          </div>
          <div className="space-y-2">
            <Label className="text-slate-300">{labels[method] || labels.paypal}</Label>
            <Input value={details} onChange={(e) => onDetailsChange(e.target.value)}
              placeholder={placeholders[method] || placeholders.paypal}
              className="bg-slate-800 border-slate-700 text-white" data-testid="payment-details" />
          </div>
        </div>
        <DialogFooter>
          <Button type="button" variant="ghost" onClick={() => onOpenChange(false)} className="text-slate-400">Cancelar</Button>
          <Button onClick={onSubmit} disabled={submitting} className="bg-emerald-600 hover:bg-emerald-500" data-testid="confirm-withdraw">
            {submitting ? <Loader2 size={16} className="animate-spin mr-2" /> : <Wallet size={16} className="mr-2" />}
            Solicitar
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
